module.exports = __webpack_public_path__ + "static/media/educationHouse.4dccb79b.svg";